import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { Container } from '../../../components/commons'
import Table from '../../../components/Table'
import Pagination from '../../../components/Table/Pagination'
import { User } from '../../../services/users.service'
import ModalDelete from '../../../components/Modals/ModalDelete'
import { NamePhoto } from './styles'
import { format, isValid } from 'date-fns'
import useDocumentTypes from '../../../services/documentTypes.service'
import CreateModal from './CreateModal'
import TableActions from '../../../components/Table/TableActions'
import { api } from '../../../services/api'
import Button from '../../../components/Button'
import InportIndexsModal from './ImportIndexsModal'
import ImportIndexsModal from './ImportIndexsModal'
import OverlayLoading from '../../../components/OverlayLoading'
import { theme } from '../../../styles/theme'

export interface UsersProps {}

export type ModalDeleteRef = React.ElementRef<typeof ModalDelete>
export type ImportIndexsModalRef = React.ElementRef<typeof ImportIndexsModal>
export type OverlayRef = React.ElementRef<typeof OverlayLoading>

type CreateRef = React.ElementRef<typeof CreateModal>

const DocumentTypes: React.FunctionComponent<UsersProps> = () => {
  const [page, setPage] = React.useState<number>(1)
  const [search, setSearch] = React.useState('')
  const modalCreate = React.useRef<CreateRef>(null)
  const [loading, setloading] = React.useState(false)

  const [sort, setSort] = React.useState<any>()

  const modalDeleteRef = React.useRef<ModalDeleteRef>(null)
  const modalImportDataRef = React.useRef<ImportIndexsModalRef>(null)
  const overlayRef = React.useRef<OverlayRef>(null)

  const { isLoading, data, refetch } = useDocumentTypes(page, 18, search, sort)

  const onSearch = (value: string) => {
    setSearch(value)
  }

  const handleCreate = () => {
    modalCreate.current?.openFormModal()
  }

  const onSortElement = (name: string, sort: string) => {
    setSort({ [name]: sort })
  }

  const handleOpenEdit = (initialData?: User) => {
    modalCreate.current?.openFormModal(initialData)
  }

  const handleSubmitDelete = async (_id?: string) => {
    try {
      setloading(true)
      await api.delete(`/documentTypes/${_id}`)
      modalDeleteRef.current?.closeModal()
      refetch()
    } catch (error) {
    } finally {
      setloading(false)
    }
  }

  const columnHelper = createColumnHelper<User>()

  const pageChangeHandler = (page: number) => setPage(page)
  const columns = [
    columnHelper.accessor('name', {
      header: () => 'Nome',
      cell: (info) => {
        return <NamePhoto>{info.getValue()}</NamePhoto>
      },
    }),
    columnHelper.accessor('createdAt', {
      header: () => 'Data de criação',
      cell: (info) => {
        try {
          const dateValue = info?.renderValue();
          if (dateValue) {
            const date = new Date(dateValue);
            if (isValid(date)) {
              return format(date, 'dd/MM/yyyy HH:mm');
            }
          }
          return '-';
        } catch (error) {
          console.warn('Erro ao formatar data de tipo de documento:', error);
          return '-';
        }
      },
    }),
    columnHelper.accessor('_id', {
      header: () => 'Ação',
      cell: (info) => {
        return (
          <TableActions
            handleEdit={() => handleOpenEdit(info.row.original)}
            handleDelete={() => modalDeleteRef.current?.openModal(info.row.original._id)}
          />
        )
      },
    }),
  ]

  return (
    <Container>
      <CreateModal ref={modalCreate} reload={refetch} />
      <div id='portalDocumentTypeModal' />

      <OverlayLoading ref={overlayRef} />
      <InportIndexsModal overlayRef={overlayRef} ref={modalImportDataRef} />
      <ModalDelete
        loading={loading}
        title='Deletar esse tipo?'
        ref={modalDeleteRef}
        onSubmitButton={handleSubmitDelete}
      />

      <div style={{ marginLeft: 'auto', backgroundColor: theme.colors.secondary }}>
        <Button
          onClick={() => modalImportDataRef.current?.openFormModal()}
          label='Importar Documentos'
          color='primary'
          variantType='block'
        />
      </div>
      <Table
        title='Tipos de Documentos'
        onSearch={onSearch}
        isLoading={isLoading}
        create={handleCreate}
        onSort={onSortElement}
        columns={columns}
        data={data?.data}
      />
      <Pagination
        totalPages={data?.totalPages}
        page={page}
        perPage={18}
        pageChangeHandler={pageChangeHandler}
      />
    </Container>
  )
}

export default DocumentTypes
